<script lang="ts">
    import type * as Pdfjs from 'pdfjs-dist/types/src/pdf';
    import type {PdfjsModule} from '../types';
    import type {TextContent} from 'pdfjs-dist/types/src/display/api';
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let module: PdfjsModule;
    export let viewport: Pdfjs.PageViewport;
    export let textContent: TextContent;

    let textLayer: Pdfjs.TextLayer;
    let textLayerElement: HTMLDivElement;
    let renderingTextLayer = true;
    let scaleFactor = 1; // CSS parameter for PDF.JS text layer scaling

    $: updateTextLayer(viewport);

    onMount(async () => {
        textLayer = createTextLayer();
        await renderTextLayer();
        updateTextLayer(viewport);
    });

    function createTextLayer(): Pdfjs.TextLayer {
        return new module.TextLayer({
            viewport,
            textContentSource: textContent,
            container: textLayerElement,
        });
    }

    async function renderTextLayer() {
        await textLayer.render();
        renderingTextLayer = false;
    }

    function updateTextLayer(pageViewport: Pdfjs.PageViewport) {
        if (!exists(textLayer)) {
            return;
        }

        textLayer.update({viewport: pageViewport});
        scaleFactor = pageViewport.scale;
    }
</script>

<div class="mv-pdf-page-text-layer textLayer"
     style:--scale-factor="{scaleFactor}"
     bind:this={textLayerElement}
     class:rendering={renderingTextLayer}></div>

<style lang="less">
    @import "pdfjs-dist/web/pdf_viewer.css";

    .mv-pdf-page-text-layer {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        transition: visibility 0.3s ease-in-out, opacity 0.3s ease-in-out;

        &.rendering {
            opacity: 0;
            visibility: hidden;
        }
    }
</style>